import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../../utils/ModalEventListener";

const ApprovePaymentModal = ({
  RCLimit,
  stepDetails,
  otherSubmissionFunc,
  closeApprovePaymentModal,
}) => {
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeApprovePaymentModal);
  }, [closeApprovePaymentModal]);

  let { btnSubmitType, stageSubmitVal, substageSubmitVal } = stepDetails;

  const otherSubmit = (e) => {
    otherSubmissionFunc(
      btnSubmitType,
      stageSubmitVal,
      substageSubmitVal,
      "dtStage2"
    );
    closeApprovePaymentModal();
  };
  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="approve-payment-modal-content" ref={ref}>
        <div className="modal-header" style={{ height: "100px" }}>
          <button
            type="button"
            className="close"
            onClick={closeApprovePaymentModal}
          >
            <span>×</span>
          </button>
          <h4 className="modal-title" id="myModalLabel2">
            Would you like to proceed?
          </h4>
          {RCLimit.is_rclimit_consumed ? (
            <div className="rcLimitErr">
              <span className="errorTxt">Warning</span>:{" "}
              {RCLimit.rclimit_warning}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn rc-btn_primary pad-L20 pad-R20"
            onClick={(e) => otherSubmit(e)}
          >
            Yes
          </button>
          <button
            type="button"
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeApprovePaymentModal}
          >
            No
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default ApprovePaymentModal;
